<div class="entities-table__header" [ngClass]="{ selected: selected }">
  <div class="header">
    <h4 class="title" [title]="mapTitle(title)">{{ mapTitle(title) }}</h4>
    <div class="category-description">
      <span class="cdk-visually-hidden">{{ category.description }}</span>
      <mat-icon [matTooltip]="category.description">info</mat-icon>
    </div>
  </div>
</div>
